import PropTypes from 'prop-types';
import classnames from 'classnames';
import Section from '../Section.jsx';
import styles from './SectionText.module.scss';

function SectionText({ className, children }) {
  return (
    <Section scrub className={ styles.section }>
      <div className={ classnames(className) }>
        { children }
      </div>
    </Section>
  );
}

SectionText.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default SectionText;
